import Api from './api'
import response from 'fe-coms/utils/response'
import Vue from '@/app.js'

const http = new Vue().$http

const action = {
  getUserInfo () {
    return new Promise((resolve, reject) => {
      const api = Api.getLoginUser
      response(http(api.type, api.url), {authError: false, tokeInvalidError: false, showError: false}).then((data) => {
        resolve(data.isOk && data.content)
      }).catch(err => {
        reject(err)
      })
    })
  },
  async getBaseInfo ({dispatch, commit}) {
    const isLogin = await dispatch('getUserInfo')
    return new Promise((resolve, reject) => {
      const api = Api.homeBasic
      const params = {
        set: [1, 2, 3, 4, 5]
      }
      response(http(api.type, api.url, params)).then((data) => {
        const content = data.content || {}
        if (data.isOk) {
          // 游客模式地址缓存
          if (!isLogin) {
            const cacheSite = window.localStorage.getItem('cacheNoLoginSite') || null
            if (cacheSite) {
              commit('SET_SITE', JSON.parse(cacheSite))
              resolve({...data, content: JSON.parse(cacheSite)})
              return
            }
          }
          const site = content.thisSite || null
          const assignData = {
            ...data,
            content: site
          }
          if (content.thisSite && content.thisSite.cityCode && content.thisSite.provinceCode) {
            window.localStorage.setItem('cacheNoLoginSite', JSON.stringify(site))
            commit('SET_SITE', site)
          }
          resolve(assignData)
          return
        }
        resolve(data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取缓存区域
  async getSite ({dispatch, commit}) {
    const isLogin = await dispatch('getUserInfo')
    return new Promise((resolve, reject) => {
      let api = Api.getSite
      response(http(api.type, api.url)).then((result) => {
        if (result.isOk && result.content) {
          let {cityCode = '', cityName = '', provinceCode = '', provinceName = '', countyCode = '', countyName = '', townCode = '', townName = ''} = result.content || {}
          const site = {cityCode, cityName, provinceCode, provinceName, countyCode, countyName, townCode, townName}
          // 游客模式地址缓存
          if (!isLogin) {
            const cacheSite = window.localStorage.getItem('cacheNoLoginSite') || null
            if (cacheSite) {
              commit('SET_SITE', JSON.parse(cacheSite))
              resolve({ ...result, content: JSON.parse(cacheSite) })
              return
            }
          }
          window.localStorage.setItem('cacheNoLoginSite', JSON.stringify(site))
          commit('SET_SITE', site)
          resolve(result)
        } else {
          dispatch('getBaseInfo').then(data => {
            resolve(data)
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 删除缓存区域
  async setSite ({dispatch, commit}, site) {
    const isLogin = await dispatch('getUserInfo')
    return new Promise((resolve, reject) => {
      // 游客模式地址缓存
      if (!isLogin) {
        window.localStorage.setItem('cacheNoLoginSite', JSON.stringify(site))
        commit('SET_SITE', site)
        const responseData = {
          code: 'success',
          content: site,
          isOk: true,
          requestState: true,
          success: true
        }
        resolve(responseData)
        return
      }
      let api = Api.setSite
      let param = {
        cityCode: site.cityCode,
        provinceCode: site.provinceCode,
        countyCode: site.countyCode,
        townCode: site.townCode
      }
      if (!param.cityCode) {
        delete param.cityCode
      }
      if (!param.provinceCode) {
        delete param.provinceCode
      }
      if (!param.countyCode) {
        delete param.countyCode
      }
      if (!param.townCode) {
        delete param.townCode
      }
      response(http(api.type, api.url, param)).then((result) => {
        if (result.isOk) {
          dispatch('getSite').then((res) => {
            if (result.isOk) {
              let site = res.content || {}
              commit('SET_SITE', site)
            }
            resolve(result)
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default action
